























































































import { getAgencies } from '@/api/Agency/agency.api'
import AutocompleteVue from '@/components/Autocomplete.vue'
import { filterMixin } from '@/utils/mixins/filterMixin'
import { getUsers } from '@/api/Users/users.api'
import UserListItem from '@/components/UserListItem.vue'
import { DatePicker } from '@/utils/interfaces'
import RangeDatePicker from '@/components/RangeDatePicker.vue'
import transactionTypes from '@/utils/transactionTypes.constant'
import FlatFilter from '~/components/FlatFilter.vue'

export default filterMixin.extend({
  components: {
    appAutocomplete: AutocompleteVue,
    appUsersListItem: UserListItem,
    appRangeDatePicker: RangeDatePicker,
    FlatFilter,
  },
  data: function() {
    return {
      getAgencies: getAgencies,
      getUsers: getUsers,
      creditItems: transactionTypes.map(type => ({
        value: type,
        text: this.$t(type),
      })),
    }
  },
  methods: {
    newFilter() {
      const dates = (this.$refs.datePicker as DatePicker).getData()
      const filter = {
        ...this.filter,
        created_at__gte: dates.minDate,
        created_at__lte: dates.maxDate,
      } as { [key: string]: any }
      this.$emit('filter', filter)
    },
  },
})
